module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("YEAR OF FEAR")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Jocelyn")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Be alert and of sober mind. Your enemy the devil prowls around like a roaring lion looking for someone to devour.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("1 PETER 5:8")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("W")])]), _vm._v("hile her husband was deployed with the National Guard, Rebekah Benimoff’s four-year-old son was diagnosed with type one diabetes. What they didn’t know at the time was that little Tyler also had sensory processing issues, making the necessary insulin shots truly traumatic.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In the coming months, Rebekah put her grief on hold as she tried desperately to “conquer” diabetes, all the while consumed with fear that her son would die. With her husband away, she, Tyler, and her one-year-old son Blaine moved in with her parents. Rebekah checked Tyler’s blood sugar six to eight times a day, counted his carbs, and administered the shots while her mother held down her hysterical son.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("For much of that year, terror hounded Rebekah as Tyler suffered multiple seizures and episodes of incoherence. And once the little boy realized that shots came with food, he refused to eat. “I was pounded with fears for my son’s life with each fight over a meal, each blood glucose test, each low blood glucose incident,” Rebekah said. “The enemy "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("was having a heyday at my expense. I was allowing my fear to pull me away from the very One who could have helped me through such a difficult season. And so I bought into the lie that I was alone and became paralyzed by fear.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Most likely you can relate. Especially during the “diagnosis year,” there are many adjustments and unknowns to deal with, not to mention a tangle of emotions to work through. Just as Eve believed Satan when she was alone with him in the garden of Eden, we are vulnerable to believing the Great Deceiver when we are alone with our fears. Be aware of this tactic! Don’t be fooled. You are not alone. “The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" himself goes before you and will be with you; he will never leave you nor forsake you. Do not be afraid; do not be discouraged” (Deut. 31:8).")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When Satan whispers to your soul that God doesn’t care what you’re going through, combat that lie with the truth: “Cast all your anxiety on him "), _c('i', [_vm._v("because he cares for you")]), _vm._v("” (1 Peter 5:7, emphasis added). The very next verse warns us, “Be alert and of sober mind. Your enemy the devil prowls around like a roaring lion looking for someone to devour.” I believe these two verses are side by side for a reason. When we tell God how we really feel, allow him to shoulder our burden, and believe that he is intimately concerned with our lives, we are better able to be alert to our prowling enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Don’t be shy about asking a trusted friend to pray for you too. As Rebekah said, “You do not have to ‘deal’ with fear; instead, wage war.” And in any battle, it would be foolhardy not to call for reinforcements when you need them. Seek out support, whether it’s your church, your family, friends, an online group, your pastor, or a counselor.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Fear can either drive us away from the Lord or bring us to our knees. Next time you feel assaulted by fear, fight back, and know that you are not battling alone. “Be strong and courageous. Do not be frightened, and do not be dismayed, for the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God is with you wherever you go” (Josh. 1:9 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESV")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('i', [_vm._v("Lord, give me strength and courage. Remind me hourly that you are with me, and guide me to the right people you’ve already chosen to help me walk through this. Help me deflect each of Satan’s lies with your truths. Unshackle me from fear. In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("When you’re afraid, what do you tend to do?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The last time you were afraid, did you move toward or away from God? How?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What was the underlying belief that caused you to respond that way?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-836fd1f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter07.vue
// module id = 102
// module chunks = 0